<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
 
export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #01326C;
  color: #fff;
}
 
.materialCheckbox label.custom-control-label {
    margin-left: 5px !important;
}
</style>
